import {
  useState, useCallback, useEffect, useContext
} from 'react';

import {
  getGrantItemsForPaidHolidayGrantHistory,
  downloadPaidHolidayGrantHistoryCsv,
} from 'api/holidayManagement';
import PaidHolidayGrantHistoryDomain from 'domain/master/holidayManagement/paidHolidayGrantHistory';
import { HolidayManagementContext } from './../../HolidayManagementForm'

export const useGrantHistoryDomainForm = () => {
  const sessionStorageOrgCode = sessionStorage.getItem('loginUser.orgCode') || '';
  const [paidHolidayGrantHistoryList, setPaidHolidayGrantHistoryList] = useState<Array<PaidHolidayGrantHistoryDomain>>([]);
  const [noManager, setNoManager] = useState(false);
  const [orgCode, setOrgCode] = useState(sessionStorageOrgCode);
  const yearCurrent = new Date().getFullYear().toString();
  const [targetDateFrom, setTargetDateFrom] = useState<Date>(new Date(`${yearCurrent}/01/01`));
  const [targetDateTo, setTargetDateTo] = useState<Date>(new Date(`${yearCurrent}/12/31`));
  const [paidGrantResult, setPaidGrantResult] = useState('0');
  const [modalOpen, setModalOpen] = useState(false);

  const contextObject = useContext(HolidayManagementContext);

  // データの取得
  const fetchData = useCallback(async () => {
    contextObject.setIsLoading(true);
    const response = await getGrantItemsForPaidHolidayGrantHistory(
      orgCode !== 'all' ? orgCode : '',
      targetDateFrom,
      targetDateTo,
      paidGrantResult,
    );
    contextObject.setIsLoading(false);
    setPaidHolidayGrantHistoryList(response.map((result) => new PaidHolidayGrantHistoryDomain(result)));
  }, [orgCode, paidGrantResult, targetDateFrom, targetDateTo]);

  useEffect(() => {
    fetchData();
  }, [fetchData, noManager, orgCode, paidGrantResult, targetDateFrom, targetDateTo]);

  const toggleNoManager = useCallback(() => {
    setNoManager(!noManager);
  }, [noManager]);

  const closeModal = useCallback(() => {
    setModalOpen(false);
  }, []);

  return {
    paidHolidayGrantHistoryList,
    toggleNoManager,
    orgCode,
    setOrgCode,
    targetDateFrom,
    setTargetDateFrom,
    targetDateTo,
    setTargetDateTo,
    paidGrantResult,
    setPaidGrantResult,
    modalOpen,
    setModalOpen,
    closeModal,
  };
};

export const useDownloadHolidayManagementGrantHistory = (
  orgCode: string,
  targetDateFrom: Date,
  targetDateTo: Date,
  paidGrantResult: string,
) => {
  const [blocking, setBlocking] = useState(false);
  const downloadHolidayManagementGrantHistory = useCallback((isDownloadAll?: boolean) => {
    setBlocking(true);
    downloadPaidHolidayGrantHistoryCsv(
      isDownloadAll ? '' : orgCode,
      targetDateFrom,
      targetDateTo,
      paidGrantResult,
    ).then((response) => {
      setBlocking(false);
    });
  }, [orgCode, paidGrantResult, targetDateFrom, targetDateTo]);

  return {
    downloadHolidayManagementGrantHistory,
    blocking
  };
};

export default {
  useGrantHistoryDomainForm,
};
